import Highcharts from "highcharts/highmaps";

import getDealHcKeys from "./getDealHcKeys";

const performAutoDrilldown =
  (dealsCountByHcKey: Record<string, number>) => (chart: Highcharts.Chart) => {
    if (dealsCountByHcKey.length === 0) {
      return;
    }

    const countries = Object.keys(dealsCountByHcKey).reduce<Set<string>>((result, hcKey) => {
      const [countryHCKey] = getDealHcKeys(hcKey);

      if (countryHCKey) {
        result.add(countryHCKey);
      }

      return result;
    }, new Set());

    if (countries.size === 1) {
      const country = Array.from(countries)[0];
      try {
        // `drilldown` is a prop required bu drilldown plugin but it's not listed in `Highcharts.Point` interface
        const point = chart.series[0].data.find((point) => (point as any).drilldown === country);

        // unofficial api + there's always a chance there's no such point
        (point as any)?.doDrilldown?.();
      } catch {
        // do nothing
      }
    }
  };

export default performAutoDrilldown;
